/*       */
import Immutable from 'app/utils/immutable/Immutable';

export const SET_WINDOW_SIZE = '@@affectli/global/SET_WINDOW_SIZE';

export const setWindowSize = ({ width, height }) => (dispatch, getState) => {
    dispatch({ type: SET_WINDOW_SIZE, payload: Immutable({ width, height }) });
};
